import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import OpeningHour from 'PMT/entities/OpeningHour';


class OpeningHourView extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    openingHour: PropTypes.instanceOf(OpeningHour).isRequired,

    // params: openingHour (OpeningHour)
    onDelete: PropTypes.func.isRequired,

    readOnly: PropTypes.bool
  };

  // -- actions
  onDelete = () => {
    this.props.onDelete(this.props.openingHour);
  };

  // -- renderers

  render() {
    return (
      <div className="opening_hours_for_day__hour">
        {this.props.openingHour.getFormatted()}
        {!this.props.readOnly &&
          <span>
            &nbsp;&nbsp;&nbsp;
            <a
              className="link"
              onClick={this.onDelete}
            >
              <i className="fa fa-trash" />
            </a>
          </span>
        }
      </div>
    );
  }

}

export default OpeningHourView;
